export const optionsBase = (window as any)._dropdownOptions_Base;

export const optionsCC = (window as any)._dropdownOptions_Cc;

export const businessTypes_IsCompany: number[] = (
  (window as any)._dropdownOptions_Cc.businessTypes as any[]
)
  .filter((x) => x.isCompany)
  .map((x) => x.value as number);
